import * as React from 'react';
import Loader from '../Loader';
import Select from 'antd/lib/select';
import withStyles from 'react-jss';
import { CommonProps } from './common.intefaces';
import { useDebounce } from 'src/hooks/useDebounce';
import { SEARCH_TIMEOUT } from 'src/Library/Constants';
import { isValidArray } from 'src/Library/Helper';
import { commonStyles } from 'src/Library/CommonStyles';
import { StylesProps } from 'src/Library/Types';
import { fetchAddresses, getAddress } from 'src/api/organisationProfiling';
import { tokens } from 'src/design-system';
import { SEAddressType, SEConsignorAddress, SELocationType } from 'src/components/pages/shipment-execution/SE.interfaces';
import { message } from 'antd';
import _ from 'lodash';


const styles = (theme) => ({
  ...commonStyles(theme),
  loaderContainer: {
    padding: tokens.spacing.lg,
  },
});
interface IProps extends CommonProps, StylesProps<ReturnType<typeof styles>> {
  addressType: SEAddressType;
  locationType: SELocationType;
  shipperId?: string;
}

const SelectPlant = (props: IProps) => {

  const {
    mode,
    style,
    value,
    classes,
    disabled,
    onChange,
    className,
    placeholder,
    addressType,
    locationType,
    shipperId,
  } = props;

  const [plants, setPlants] = React.useState<SEConsignorAddress[]>([]);
  const [selectedPlant, setSelectedPlant] = React.useState<SEConsignorAddress | undefined>();
  const [searching, setSearching] = React.useState<boolean>(false);
  const [queryString, setQuery] = React.useState<string>('');
  const latestSearchId = React.useRef<number>(0);

  const handlePlantSearch = async () => {
    const searchId = ++latestSearchId.current;
    setSearching(true);
    const response = await fetchAddresses({ addressType, locationType, queryString, shipperId });
    // Ignore responses of older searches so they don't overwrite newer results
    if (searchId !== latestSearchId.current) return;
    if (response.isSuccess) {
      setPlants(response.data || []);
    } else {
      message.error(response.errorMessage);
    }
    setSearching(false);
  };

  const fetchAddressById = async (id: string) => {
    let stakeholderId: string | undefined;
    const { shipperId } = props;
    if (shipperId) stakeholderId = shipperId;
    const response = await getAddress(id, stakeholderId);
    if (response.isSuccess) {
      setSelectedPlant(response.data);
    } else {
      message.error(response.errorMessage);
    }
  };

  React.useEffect(() => {    
    if (_.isObject(value) && !Array.isArray(value) && value?.key != null){
      fetchAddressById(value?.key as string);
    } else if (!value) {
      setSelectedPlant(undefined);
    }
  }, [value]);
  
  const debounceTime = useDebounce(queryString, SEARCH_TIMEOUT);
  React.useEffect(() => {
    // Only search if there's actually a query string (not on initial mount with empty string)
    if (debounceTime !== undefined && debounceTime !== '') {
      setSearching(true);
      handlePlantSearch();
    }
  }, [debounceTime]);

  React.useEffect(() => {
    if (!value && queryString) {
      setQuery('');
    }
  }, [value]);

  const dropdownRender = (menu) => {
    if (searching) return <div
      className={classes.loaderContainer}>
      <Loader />
    </div>;
    return menu;
  };

  const renderPortOptions = () => {
    // Keep the selected address in the unfiltered list so a prefilled value resolves its label;
    // while searching, show only matches (rc-select retains the selected label on its own)
    const options = !queryString && selectedPlant && !plants.some(plant => plant.id === selectedPlant.id)
      ? [selectedPlant, ...plants]
      : plants;
    return options.map((plant) => <Select.Option
      key={plant.id}
      {...plant}
      data-value={plant.name}
    >
      {plant.name}
    </Select.Option>) || [];
  };

  return <Select
    style={{
      ...(style || {}),
    }}
    allowClear
    showSearch
    labelInValue
    value={value}
    disabled={disabled}
    className={className}
    onChange={onChange}
    optionLabelProp="data-value"
    mode={mode || 'default'}
    dropdownRender={dropdownRender}
    onSearch={query => setQuery(query)}
    onFocus={() => handlePlantSearch()}
    filterOption={(inputValue, option) => true}
    placeholder={placeholder || 'Select Ports(s)'}
    getPopupContainer={(trigger: any) => trigger.parentNode}
  >
    {renderPortOptions()}
  </Select>;
};

export default React.memo(withStyles(styles)(SelectPlant));
